// import { useState } from "react";
// import { NavLink } from "react-router-dom";
// import "../styles/Header.css";

// export default function Header() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const closeMenu = () => setMenuOpen(false);

//   return (
//     <header className="header">

//       <div className="container nav-container">

//         {/* LOGO */}
//         <div className="logo">
//           JAT TECHNOCRAFT
//         </div>

//         {/* HAMBURGER */}
//         <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
//           ☰
//         </div>

//         {/* NAV */}
//         <nav className={`nav ${menuOpen ? "active" : ""}`}>

//           <ul className="nav-links">

//             <li onClick={closeMenu}>
//               <NavLink to="/" className={({ isActive }) => isActive ? "active-link" : ""}>
//                 Home
//               </NavLink>
//             </li>

//             <li onClick={closeMenu}>
//               <NavLink to="/aboutus" className={({ isActive }) => isActive ? "active-link" : ""}>
//                 About Us
//               </NavLink>
//             </li>

//             <li onClick={closeMenu}>
//               <NavLink to="/services" className={({ isActive }) => isActive ? "active-link" : ""}>
//                 Services
//               </NavLink>
//             </li>

//             <li onClick={closeMenu}>
//               <NavLink to="/infrastructure" className={({ isActive }) => isActive ? "active-link" : ""}>
//                 Infrastructure
//               </NavLink>
//             </li>

//             <li onClick={closeMenu}>
//               <NavLink to="/contactus" className={({ isActive }) => isActive ? "active-link" : ""}>
//                 Contact
//               </NavLink>
//             </li>

//           </ul>

//         </nav>

//       </div>

//     </header>
//   );
// }















import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../styles/Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">

      <div className="container nav-container">

        {/* LOGO */}
        <div className="logo">
          JAT TECHNOCRAFT
        </div>

        {/* HAMBURGER */}
        <div
          className="menu-icon"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? "✕" : "☰"}
        </div>

        {/* NAVIGATION */}
        <nav className={`nav-menu ${menuOpen ? "active" : ""}`}>

          <ul className="nav-links">

            <li onClick={closeMenu}>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "active-link" : ""
                }
              >
                Home
              </NavLink>
            </li>

            <li onClick={closeMenu}>
              <NavLink
                to="/aboutus"
                className={({ isActive }) =>
                  isActive ? "active-link" : ""
                }
              >
                About Us
              </NavLink>
            </li>

            <li onClick={closeMenu}>
              <NavLink
                to="/services"
                className={({ isActive }) =>
                  isActive ? "active-link" : ""
                }
              >
                Services
              </NavLink>
            </li>

            <li onClick={closeMenu}>
              <NavLink
                to="/infrastructure"
                className={({ isActive }) =>
                  isActive ? "active-link" : ""
                }
              >
                Infrastructure
              </NavLink>
            </li>

            <li onClick={closeMenu}>
              <NavLink
                to="/contactus"
                className={({ isActive }) =>
                  isActive ? "active-link" : ""
                }
              >
                Contact
              </NavLink>
            </li>

          </ul>

        </nav>

      </div>

    </header>
  );
}